module.exports = __webpack_public_path__ + "static/prenom_nom-3b57e8809647f05254b23b175f276970.png";